import WidgetItems      from "./item/WidgetItems";
import WidgetCoordinate from "./WidgetCoordinate";
import WidgetId         from "./WidgetId";
import WidgetTitle      from "./WidgetTitle";
import WidgetTypeClass  from "./WidgetTypeClass";
import WidgetValue      from "./WidgetValue";

class Widget {
  constructor(
    private readonly _id: WidgetId = new WidgetId(),
    private readonly _type: WidgetTypeClass = new WidgetTypeClass(),
    private readonly _coordinate: WidgetCoordinate = new WidgetCoordinate(),
    private readonly _title: WidgetTitle = new WidgetTitle(),
    private readonly _value: WidgetValue = new WidgetValue(),
    private readonly _items: WidgetItems = new WidgetItems()
  ) {
  }

  get id() {
    return this._id;
  }

  get type() {
    return this._type;
  }

  get coordinate() {
    return this._coordinate;
  }

  get title() {
    return this._title;
  }

  get value() {
    return this._value;
  }

  get items() {
    return this._items;
  }
}

export default Widget;
